import { SelectableMenuItem, ItemCardSelectionInfoKind } from '@/models';
import { Logger } from '@/services/logger/logger';

export interface ItemSelector<TArgs> {
  selectItem(item: SelectableMenuItem, args?: TArgs): boolean;
  deselectItem(item: SelectableMenuItem): void;
  getItemQuantity(item: SelectableMenuItem): number;
  getEffectiveItemQuantity(item: SelectableMenuItem): number;
  getMaxQuantity(item: SelectableMenuItem): number;
  isItemSelected(item: SelectableMenuItem): boolean;
  isDeselecting(item: SelectableMenuItem, args: TArgs): boolean;
  getQuantityAfterSelection(item: SelectableMenuItem, args: TArgs): number;

  /**
   * Copies the selection status from src -> target
   * @param shallowSelection Whether the target item selection status should just be migrated to target or if the app should be made aware of the selection
   */
  copySelectionTo(target: SelectableMenuItem, src: SelectableMenuItem, shallowSelection: boolean): boolean;
}

export abstract class AbstractItemSelector<TArgs = void> implements ItemSelector<TArgs> {
  constructor(protected logger: Logger) {}

  abstract getSelectionKind(): ItemCardSelectionInfoKind;
  abstract selectItem(item: SelectableMenuItem, args: TArgs): boolean;
  abstract deselectItem(item: SelectableMenuItem): void;
  abstract isItemSelected(item: SelectableMenuItem): boolean;
  abstract isDeselecting(item: SelectableMenuItem, args: TArgs): boolean;
  abstract getQuantityAfterSelection(item: SelectableMenuItem, args: TArgs): number;
  abstract getItemQuantity(item: SelectableMenuItem): number;
  abstract getEffectiveItemQuantity(item: SelectableMenuItem): number;
  abstract getMaxQuantity(item: SelectableMenuItem): number;
  abstract copySelectionTo(target: SelectableMenuItem, src: SelectableMenuItem): boolean;
}